import { NgModule } from "@angular/core";
import { BackgroundModifierDirective } from "./colors.directive";
import { DimensionModifierDirective } from "./dimensions.directive";
import { ExpandModifierDirective } from "./expand.directive";
import { MarginModifierDirective } from "./margin.directive";
import { PaddingModifierDirective } from "./padding.directive";
import { PlaceholderElementDirective } from "./placeholder-element.directive";
import { PositionModifierDirective } from "./positions.directive";
import { TabIndexModifierDirective } from "./tabindex.directive";
import { TextModifierDirective } from "./text.directive";
import { TopNavOffsetModifierDirective } from "./top-nav-offset.directive";

@NgModule({
    imports: [],
    exports: [
        DimensionModifierDirective,
        MarginModifierDirective,
        PaddingModifierDirective,
        TextModifierDirective,
        BackgroundModifierDirective,
        ExpandModifierDirective,
        PlaceholderElementDirective,
        PositionModifierDirective,
        TabIndexModifierDirective,
        TopNavOffsetModifierDirective,
    ],
    declarations: [
        DimensionModifierDirective,
        MarginModifierDirective,
        PaddingModifierDirective,
        TextModifierDirective,
        BackgroundModifierDirective,
        ExpandModifierDirective,
        PlaceholderElementDirective,
        PositionModifierDirective,
        TabIndexModifierDirective,
        TopNavOffsetModifierDirective,
    ],
    providers: [],
})
export class ModifiersModule {
}
